import installPrep from './install-prep.jpg';

const InstallPrep = (): JSX.Element => (
    <img alt="Construction crew preparing to install medical equipment" src={installPrep} />
);

export default InstallPrep;